import { Breadcrumbs, Container, Link, Stack, Typography } from "@mui/material";
import MenuMenu from "./MenuMenu";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useEffect, useRef, useState } from "react";
import parse from 'html-react-parser';
import axios from "axios";
import { API } from "./constantsFront";

/**
 * プライバシーポリシー
 * @returns 
 */
const D011PrivacyPolicy = () => {
  const [privacyDetail, setPrivacyDetail] = useState("");   //利用規約・免責事項詳細
  let body = { authKey: API.API_KEY };
  const preview = localStorage.getItem("privacypreview");
  let previewdata = JSON.parse(preview);
  localStorage.removeItem("privacypreview");

  const refIsFirst = useRef(true);
  useEffect(() => {
    //初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    if (!previewdata) {
      //DBの内容を表示
      axios.post("/m_privacy_policy/select/publish", body).then(res => {
        let privacy = res.data.privacy
        setPrivacyDetail(parse(privacy[0].content))
      })
    } else {
      //プレビュー表示
      setPrivacyDetail(parse(previewdata.content))
    }

    //初回読込フラグをfalseにセット
    refIsFirst.current = false;
  })

  return (
    <>
      <MenuMenu sel={0} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
                <Stack spacing={2}>

                  <Breadcrumbs
                    separator={<NavigateNextIcon fontSize="small" />}
                    aria-label="breadcrumb"
                  >
                    <Link underline="hover" key="1" color="inherit" href="./" style={{ fontSize: "14px" }}>
                      TOP
                    </Link>,
                    <Typography key="2" color="text.primary" style={{ fontSize: "14px" }}>
                      プライバシーポリシー
                    </Typography>
                  </Breadcrumbs>

                  <h1>プライバシーポリシー</h1>

                  {privacyDetail}

                  {/* 2023/05/12:DBからのデータを表示するためコメントアウト。FAX番号はこの時すでにコメントアウトされていました。 */}
                  {/* <p class="table-title">１.基本的考え方</p>
                  <div>
                    農林水産省では、海外の食品規則チェックサイト(以下「当サイト」という。)において提供するサービス(webサイトによる情報提供お問い合わせの受付等)の円滑な運営に必要な範囲で、当サイトを利用される皆様の情報を収集しています。収集した情報は利用目的の範囲内で適切に取り扱います。
                  </div>
                  <br />

                  <p class="table-title">２.収集する情報の範囲</p>
                  <ul style={{ listStyleType: "inherit", marginLeft: "20px" }}>
                    <li >
                      当サイトでは、IPアドレス、その他当サイト閲覧等の情報を自動的に取得します。<br />
                      なお、アクセスログの収集及び解析を目的として、「GoogleAnalytics」を使用しています。<br />
                      GoogleAnalyticsでは、クッキーを使用し、利用者の情報を収集していますが、利用者個人を特定する情報は収集していません。GoogleAnalytics
                      により収集される情報は、Googleのプライバシーポリシーに基づき、管理されます。
                      詳細はこちらから「Googleプライバシーポリシー」(外部リンク)をご確認ください。
                    </li>
                    <li>
                      クッキーについて<br />
                      当サイトでは、クッキーを使用しています。<br />
                      クッキーは、利用者がサイトにアクセスした際に、サイトのサーバと利用者のブラウザとの間でやり取りされ、利用者のコンピュータに保存されます。<br />
                      利用者はブラウザ設定から、クッキーの無効化を選択することで、アクセスログの収集を拒否することができます。<br />
                      なお、クッキーを無効化しても、当サイトの閲覧には影響はありません。<br />
                      ブラウザの設定方法は、各ブラウザのヘルプページ又は製造元へお問い合わせください。
                    </li>
                    <li>
                      「お問い合せ」のご利用にあたっては、メールアドレス等の記入をお願いしております。
                    </li>
                  </ul>
                  <br />

                  <p class="table-title">３.利用目的</p>
                  <ul style={{ listStyleType: "inherit", marginLeft: "20px" }}>
                    <li >
                      2.の1.及び2.において収集した情報は、当サイトが提供するサービスを円滑に運営するための参考として利用させていただきます。
                    </li>
                    <li >
                      2.の3.で収集したお問い合せは、任意で記入いただいた事項も含めて今後の施策立案の参考とさせていただきます。また、お問い合わせの 回答や確認のご連絡のため、メールアドレス、ご住所、お名前、電話番号を利用します。なお、これらの情報は内容に応じ、農林水産省内の関係部署、関係府省等に転送することがあります。
                    </li>
                  </ul>
                  <br />

                  <p class="table-title">４.利用及び提供の制限</p>
                  <div>
                    農林水産省では、法令に基づく開示要請があった場合、不正アクセス、脅迫等の違法行為があった場合その他特別の理由のある場合を除
                    き、収集した情報を3の利用目的以外の目的のために自ら利用し、又は第三者に提供いたしません。ただし、統計的に処理された当サイトの
                    アクセス情報、利用者属性等の情報については公表することがあります。
                  </div>
                  <br />

                  <p class="table-title">５.安全確保の措置</p>
                  <div>
                    農林水産省は、収集した情報の漏えい、滅失又はき損の防止その他収集した情報の適切な管理のために必要な措置を講じます。
                  </div>
                  <br />

                  <p class="table-title">６.適用範囲</p>
                  <ul style={{ listStyleType: "inherit", marginLeft: "20px" }}>
                    <li >
                      本プライバシーポリシーは、当サイトにおいてのみ適用されます。関係府省等のサイトにおける情報の収集等については、それぞれの組織の責任において行われることになります。
                    </li>
                  </ul>
                  <br />

                  <p class="table-title">７.その他</p>
                  <div>
                    農林水産省では、以上の農林水産省Webサイト・プライバシーポリシーを必要に応じて改定することがあります。
                  </div>
                  <br />

                  <div style={{ fontWeight: "700", color: "#1B335E" }}>
                    お問い合わせ先
                  </div>
                  <div style={{ border: "1px solid #A6A8AC", padding: "10px 20px 10px 20px" }}>
                    <div style={{ fontWeight: "700", margin: "0px 0 10px 0" }}>
                      輸出・国際局輸出支援課輸出産地形成室
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{
                        backgroundColor: "#F2F3F7"
                        , color: "#1B335E"
                        , width: "100px"
                        , display: "flex"
                        , alignItems: "center"
                        , justifyContent: "center"
                      }}>
                        代表
                      </div>
                      <Stack spacing={0} direction={{ xs: 'column', md: 'row' }} style={{ marginLeft: "20px" }}>
                        <div>03-3502-8111</div>
                        <div>（内線4364）</div>
                      </Stack>
                    </div>
                    <hr style={{ margin: "10px 0 10px 0" }} />
                    <Stack spacing={2} direction={{ xs: 'column', md: 'row' }} >
                      <div style={{ display: "flex", minWidth: "50%" }} >
                        <div style={{
                          backgroundColor: "#F2F3F7"
                          , color: "#1B335E"
                          , width: "100px"
                          , textAlign: "center"
                        }}>
                          ダイヤルイン
                        </div>
                        <div style={{ marginLeft: "20px" }}>03-6738-7897</div>
                      </div> */}
                  {/* <div style={{ display: "flex" }}>
                        <div style={{
                          backgroundColor: "#F2F3F7"
                          , color: "#1B335E"
                          , width: "100px"
                          , textAlign: "center"
                        }}>
                          FAX番号
                        </div>
                        <div style={{ marginLeft: "20px" }}>03-3502-8766</div>
                      </div> */}
                  {/* </Stack>

                  </div> */}

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default D011PrivacyPolicy;